import Tooltip, { useTooltip, TooltipPlace } from './Tooltip';
export default Tooltip;
export { useTooltip, TooltipPlace };
